import { useContext } from 'react';

import { AtypicalDealsContext } from '../contexts/atypical-deals-context';

export const useAtypicalDealsContext = () => {
  const context = useContext(AtypicalDealsContext);
  return context;
};

const useResponse = () => {
  const context = useAtypicalDealsContext();
  return context.response;
};

export const useHotelPriceBand = () => useResponse()?.priceBand ?? null;

export const usePriceBandLoadingStatus = () =>
  useAtypicalDealsContext()?.isLoading ?? null;

export const useDateRangePrices = () =>
  useAtypicalDealsContext().response?.alternativeDatePrices?.dateRangePrices ??
  null;

export const usePriceLevelInsight = () =>
  useResponse()?.priceLevelInsight ?? null;
